import { useEffect } from 'react';
import { App } from 'antd';
import { useTranslation } from 'react-i18next';
import { HashRouter as Router } from 'react-router-dom';
import nprogress from 'nprogress';
import RouterPage from './components/Router';
import StaticMessage from '@south/message';

// keepalive
import { AliveScope } from 'react-activation';

// antd
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';

// 禁止进度条添加loading
nprogress.configure({ showSpinner: false });

// antd主题（延迟解构，确保 theme 已正确初始化）
// const { defaultAlgorithm, darkAlgorithm } = theme;

// 临时注释掉，避免 React 19 兼容性问题
// import { useCommonStore } from '@/hooks/useCommonStore';

function Page() {
  const { i18n } = useTranslation();
  // 临时注释掉 theme，避免 React 19 兼容性问题
  // const { theme: currentTheme } = useCommonStore();
  // 获取当前语言
  const currentLanguage = i18n.language;

  // 临时注释掉 theme 配置，避免 React 19 兼容性问题
  // 使用 useMemo 延迟解构 theme，确保已正确初始化
  // const themeConfig = useMemo(() => {
  //   // 延迟访问 theme，确保 cssinjs 已完全初始化
  //   if (typeof window === 'undefined') {
  //     return undefined;
  //   }
  //   
  //   // 等待一个 tick，确保所有模块都已加载
  //   try {
  //     // 检查 theme 对象是否已正确初始化
  //     if (!theme || typeof theme !== 'object') {
  //       console.warn('Theme object not initialized');
  //       return undefined;
  //     }
  //     
  //     // 检查 theme 对象是否有必要的属性
  //     if (!('defaultAlgorithm' in theme) || !('darkAlgorithm' in theme)) {
  //       console.warn('Theme algorithms not available');
  //       return undefined;
  //     }
  //     
  //     const { defaultAlgorithm, darkAlgorithm } = theme;
  //     if (!defaultAlgorithm || !darkAlgorithm) {
  //       console.warn('Theme algorithms are invalid');
  //       return undefined;
  //     }
  //     
  //     return {
  //       algorithm: [currentTheme === 'dark' ? darkAlgorithm : defaultAlgorithm],
  //     };
  //   } catch (error) {
  //     console.error('Theme initialization error:', error);
  //     return undefined;
  //   }
  // }, [currentTheme]);

  useEffect(() => {
    // 关闭loading
    const firstElement = document.getElementById('first');
    if (firstElement && firstElement.style?.display !== 'none') {
      firstElement.style.display = 'none';
    }
  }, []);

  return (
    <Router>
      <ConfigProvider
        locale={currentLanguage === 'en' ? enUS : zhCN}
        // 临时移除 theme 配置，避免 React 19 兼容性问题
        // theme={themeConfig || undefined}
      >
        <App>
          <StaticMessage />
          <AliveScope>
            <RouterPage />
          </AliveScope>
        </App>
      </ConfigProvider>
    </Router>
  );
}

export default Page;
